import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AnimatedCard from "../../../../components/AnimatedCard/AnimatedCard";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import StepIndicator from "../../../../components/StepIndicator/StepIndicator";
import BackButton from "../../../../components/BackButton";
import { Button, Alert } from "@repo/ui";
import {
  getWithdrawalById,
  WithdrawResponse,
} from "../../../../services/withdrawApiService";
import {
  downloadDocument,
  DocumentDownloadResponse,
} from "../../../../services/documentsApiService";

const DonationReceiptStep3: React.FC = () => {
  const { withdrawId } = useParams<{ withdrawId: string }>();
  const navigate = useNavigate();

  const [withdrawalData, setWithdrawalData] = useState<WithdrawResponse | null>(
    null
  );
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Load withdrawal data to get donationReceiptId
  useEffect(() => {
    if (withdrawId) {
      getWithdrawalById(withdrawId)
        .then((data) => {
          setWithdrawalData(data);
        })
        .catch((err) => {
          console.error("Error retrieving withdrawal data", err);
          setError("Error al obtener la información del retiro.");
        });
    }
  }, [withdrawId]);

  // When withdrawal data is loaded and donationReceiptId exists, retrieve download URL.
  useEffect(() => {
    if (withdrawalData && withdrawalData.donationReceiptId) {
      downloadDocument(withdrawalData.donationReceiptId)
        .then((docDownload: DocumentDownloadResponse) => {
          setDownloadUrl(docDownload.download_url);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error retrieving document download URL", err);
          setError("Error al obtener el recibo de donación.");
          setLoading(false);
        });
    } else if (withdrawalData && !withdrawalData.donationReceiptId) {
      setError("No se encontró el ID del recibo de donación.");
      setLoading(false);
    }
  }, [withdrawalData]);

  // Handler for downloading the receipt.
  const handleDownload = () => {
    if (!downloadUrl) return;
    // Open the download URL in a new tab to trigger download.
    window.open(downloadUrl, "_blank");
  };

  // Finalize the process: navigate to "/my-table".
  const handleFinalize = () => {
    navigate("/my-table");
  };

  return (
    <PageContainer>
      <div className="mt-16"></div>
      <StepIndicator
        steps={["Revisión", "Firma", "Confirmación"]}
        currentStep={3}
        progressPercentage={100}
      />
      <AnimatedCard className="bg-white max-w-lg w-full">
        <BackButton text="Regresar" onClick={() => navigate(-1)} />
        <h2 className="text-2xl font-bold mb-4 text-primary">
          Recibo de donación generado
        </h2>
        <p className="text-gray-600 mb-6">
          Tu recibo de donación ha sido generado exitosamente. Haz clic en el
          botón para descargarlo.
        </p>

        {error ? (
          <Alert message={error} level="error" />
        ) : (
          <>
            <div className="flex flex-col items-center gap-4">
              <Button
                label="Descargar recibo"
                onClick={handleDownload}
                type="secondary"
                className="w-full"
              />
              <Button
                label="Finalizar"
                onClick={handleFinalize}
                type="primary"
                className="w-full"
              />
            </div>
          </>
        )}
      </AnimatedCard>
    </PageContainer>
  );
};

export default DonationReceiptStep3;
